import React, { Component } from "react";
import Select from "react-select";

class SeachableField extends Component {
  constructor() {
    super();
    this.state = {
      selected: "",
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.customFilter = this.customFilter.bind(this);
  }

  handleChange = (value) => {
    const { onChange, name } = this.props;

    onChange(name, value);
  };

  handleBlur = () => {
    const { onBlur, name } = this.props;

    onBlur(name, true);
  };

  //Add your search logic here.
  customFilter(option, inputValue) {
    if (!inputValue) {
      return true;
    } else if (
      inputValue &&
      ((option.data.label &&
        option.data.label.toLowerCase().includes(inputValue.toLowerCase())) ||
        (option.data.postcode &&
          option.data.postcode
            .toLowerCase()
            .includes(inputValue.toLowerCase())) ||
        (option.data.address &&
          option.data.address
            .toLowerCase()
            .includes(inputValue.toLowerCase())) ||
        (option.data.suburb &&
          option.data.suburb.toLowerCase().includes(inputValue.toLowerCase())))
    ) {
      return true;
    }
  }

  handleSelect(val) {
    this.setState({ selected: val });
  }

  render() {
    const {
      id,
      name,
      label,
      placeholder,
      value,
      isDisabled,
      touched,
      error,
      isClearable,
      backspaceRemovesValue,
      options,
      renderedOptions,
    } = this.props;

    return (
      <div className="input-field-wrapper">
        {label && (
          <h3 className="input-label" htmlFor={name} error={error}>
            {label}
          </h3>
        )}
        <Select
          id={id}
          placeholder={placeholder}
          options={
            renderedOptions
              ? renderedOptions
              : options &&
                options.map((option) => ({
                  label: option.name,
                  value: option._id,
                  postcode: option.postcode,
                  address: option.address,
                  suburb: option.suburb,
                }))
          }
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          touched={touched}
          error={error}
          style={error && { border: "red solid 1px" }}
          isDisabled={isDisabled}
          isClearable={isClearable}
          backspaceRemovesValue={backspaceRemovesValue}
          components={{ ClearIndicator: null }}
          filterOption={this.customFilter}
        />

        {touched && error ? <p className="error-text">{error}</p> : null}
      </div>
    );
  }
}

export default SeachableField;
